export const supportedEvents = Object.freeze([
  {order: 1, label: 'Program Timings'},
  {order: 2, label: 'Chapter'},
  {order: 3, label: 'Compliance Edits'},
  {order: 4, label: 'Quality Control'},
  {order: 5, label: 'Textless'}
]);
